import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/confirmDeleteEnrolmentModal";
import deltas from "../../actions/deltas";

const {SET_CONFIRM_DELETE_ENROLMENT_MODAL_STATE} = deltas.actionTypes;

export default createStateReducer(states, states.CLOSED, SET_CONFIRM_DELETE_ENROLMENT_MODAL_STATE);
